'use client';

import React__default from 'react';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import { HeaderContainer, AvatarCompany, TxtTruncate, CloseButton } from '../style.css.js';
import { Span } from '../../Typography/components/Variant.js';
import { colors } from '../../Colors/index.js';
import CloseIcon from '../../Images/CloseIcon/index.js';
import { ELanguage } from '../../Utils/constants.js';

function Header(_a) {
    var job = _a.job, onClose = _a.onClose, _b = _a.langCode, langCode = _b === void 0 ? ELanguage.VI : _b;
    var jobLevelText = (job === null || job === void 0 ? void 0 : job.jobLevelText) ? job === null || job === void 0 ? void 0 : job.jobLevelText : (langCode === ELanguage.VI ? job === null || job === void 0 ? void 0 : job.jobLevelVI : job === null || job === void 0 ? void 0 : job.jobLevel);
    return (React__default.createElement(HeaderContainer, null,
        React__default.createElement(Row, { gutter: 8 },
            React__default.createElement(Col, { xs: 'auto' },
                React__default.createElement(AvatarCompany, null,
                    React__default.createElement("img", { src: (job === null || job === void 0 ? void 0 : job.companyLogo) || 'https://images.vietnamworks.com/img/company-default-logo.svg', alt: 'Company logo' }))),
            React__default.createElement(Col, { xs: 'fill' },
                React__default.createElement(TxtTruncate, { name: 'title', size: 'medium', color: colors.grey[20], lineClamp: 2 }, job === null || job === void 0 ? void 0 : job.jobTitle),
                React__default.createElement(TxtTruncate, { lineClamp: 2 },
                    React__default.createElement(Span, { name: 'paragraph', size: 'medium', color: colors.secondary[40] }, job === null || job === void 0 ? void 0 : job.prettySalary),
                    React__default.createElement(Span, { name: 'paragraph', size: 'medium' },
                        ' ',
                        "|",
                        ' '),
                    React__default.createElement(Span, { name: 'paragraph', size: 'medium' }, jobLevelText)),
                React__default.createElement(TxtTruncate, { name: 'paragraph', size: 'medium', lineClamp: 1 }, job === null || job === void 0 ? void 0 : job.address)),
            React__default.createElement(CloseButton, { outline: 'none', isIcon: true, isRounded: true, onClick: onClose },
                React__default.createElement(CloseIcon, null)))));
}

export { Header as default };
//# sourceMappingURL=Header.js.map
